// tokenReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	userInformation: localStorage.getItem('user_information'),
	allUsersInCurrentOrgInfo: [],
	viewedUserInfo: 0,
	loginSessionId: null,
};

const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setUserInformation: (state, action) => {
			state.userInformation = action.payload;
		},
		setAllUsersInCurrentOrgInfo: (state, action) => {
			state.allUsersInCurrentOrgInfo = action.payload;
		},
		setViewedUserInfo: (state, action) => {
			state.viewedUserInfo = action.payload;
		},
		setLoginSession: (state, action) => {
			state.loginSessionId = action.payload;
		},
	},
});

export const { setUserInformation, setAllUsersInCurrentOrgInfo, setViewedUserInfo, setLoginSession } = userSlice.actions;
export default userSlice.reducer;